// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"search-header_headerContainer__UzNtw","headerContainer--empty":"search-header_headerContainer--empty__cNE_J","headerTitle":"search-header_headerTitle__NFFEw"};